/**
 * Krajiny škôl - rovnaké kódy ako backend (`apps/core/countries.py`).
 * Názvy dodá prehliadač v jazyku rozhrania (`Intl.DisplayNames`).
 * Krajina rozhoduje o DPH na faktúre za Learn2Ski (SR / EÚ / mimo EÚ).
 */
export const COUNTRY_CODES = [
  'SK', 'CZ', 'AT', 'PL', 'HU', 'DE', 'IT', 'FR', 'CH', 'SI',
  'AD', 'AL', 'BE', 'BA', 'BG', 'ME', 'CY', 'DK', 'EE', 'FI', 'GR', 'HR', 'IE', 'IS',
  'LI', 'LT', 'LV', 'LU', 'MT', 'MK', 'NL', 'NO', 'PT', 'RO', 'RS', 'ES', 'SE', 'TR',
  'UA', 'XK', 'GE', 'AM', 'AZ', 'KZ', 'GB', 'US', 'CA',
] as const

export function countryName(code: string, locale: string) {
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(code) ?? code
  } catch {
    return code
  }
}
